<template>
  <v-dialog
    @keydown.esc="dialog = false"
    @keydown.enter="tipo == 'edit' ? editarItem() : tipo == 'create' ? salvarItem() : ''"
    v-model="dialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span>
          <strong>{{titulo}}</strong>
        </span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click.native="dialog=false">
          <v-icon color="red">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap v-if="this.showCampoEmail">
            <v-flex xs12 sm12 md12>
              <v-text-field
                label="E-mail:"
                ref="email"
                :rules="emailRules"
                validate-on-blur
                box
                color="teal"
                cleareable
                v-model="obj.email"
                @input="emailRules.length > 0 ? emailRules.pop() : ''"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              <Opcoes
                :notificacoes="this.notificacoes"
                :opcoes="this.obj"
                v-if="this.showNotificacoes"
              ></Opcoes>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" flat @click.stop="dialog=false, resetObj()">Cancelar</v-btn>
        <v-btn
          color="success"
          @click.stop="tipo == 'edit' ? editarItem() : tipo == 'create' ? salvarItem() : ''"
        >{{btnFinishText}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Opcoes from "@/components/conta/empresa/formEmpresa/tabNotificacoes/opcoes/Opcoes.vue";
export default {
  components: { Opcoes: Opcoes },

  props: ["notificacoes", "acao", "editItem"],
  data: () => ({
    dialog: false,
    columnName: "",
    columnPesq: false,
    titulo: "",
    showCampoEmail: false,
    showNotificacoes: true,
    btnFinishText: "",
    tipo: "",
    emailRules: [],
    obj: {
      email: "",
      resumoDiario: false,
      resumoSemanal: false,
      novoFornecedor: false,
      novoCliente: false,
      vencimentoNF: false,
      notaCancelada: false,
      nvNotaNfe: false,
      nvNotaCte: false,
      nvNotaNfse: false
    },
    auxEdit: {}
  }),
  watch: {
    "acao.edit": function(newV, oldV) {
      if (newV) {
        this.dialog = true;
        this.acao.edit = false;
        this.setTipo("edit");
      }
    },
    "acao.create": function(newV, oldV) {
      if (newV) {
        this.dialog = true;
        this.acao.create = false;
        this.setTipo("create");
      }
    },
    dialog: function(newV, oldV) {
      if (!newV && this.tipo == "edit") {
      }
    }
  },
  methods: {
    setTipo(acao) {
      switch (acao) {
        case "edit":
          this.tipo = "edit";
          this.titulo = "Editar Notificações";
          this.btnFinishText = "Salvar";
          this.showCampoEmail = true;
          this.createCopia(this.editItem, this.obj);
          break;
        case "create":
          this.tipo = "create";
          this.showCampoEmail = true;
          this.titulo = "Cadastrar Novo E-mail";
          this.btnFinishText = "Cadastrar";
          break;
        default:
          throw new Error(
            "Não foi possível setar AÇÃO na notificação da empresa"
          );
      }
    },
    createCopia(obj, copia) {
      copia["email"] = obj["email"];
      copia["resumoDiario"] = obj["resumoDiario"];
      copia["resumoSemanal"] = obj["resumoSemanal"];
      copia["novoFornecedor"] = obj["novoFornecedor"];
      copia["novoCliente"] = obj["novoCliente"];
      copia["vencimentoNF"] = obj["vencimentoNF"];
      copia["notaCancelada"] = obj["notaCancelada"];
      copia["nvNotaNfe"] = obj["nvNotaNfe"];
      copia["nvNotaCte"] = obj["nvNotaCte"];
      copia["nvNotaNfse"] = obj["nvNotaNfse"];
    },
    verificaEmail() {
      if (this.obj.email == "") {
        if (this.emailRules.length > 0) {
          this.emailRules.pop();
        }
        this.emailRules.push(v => {
          return "Campo obrigatório";
        });
      }
      if (
        this.obj.email != "" &&
        !/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(
          this.obj.email
        )
      ) {
        if (this.emailRules.length > 0) {
          this.emailRules.pop();
        }
        this.emailRules.push(v => {
          return "Digite um e-mail válido";
        });
      }
      if (this.notificacoes.objetos && this.notificacoes.objetos.length > 0) {
        let auxThis = this;
        this.notificacoes.objetos.forEach(item => {
          if (item.email == auxThis.obj.email) {
            if (auxThis.emailRules.length > 0) {
              auxThis.emailRules.pop();
            }
            auxThis.emailRules.push(v => {
              return "E-mail já está cadastrado para está empresa.";
            });
          }
        });
      }
    },
    async editarItem() {
      if (this.editItem.email != this.obj.email) {
        await this.verificaEmail();
      }
      if (this.$refs.email.validate()) {
        this.editItem.email = this.obj.email;
        this.editItem.resumoDiario = this.obj.resumoDiario;
        this.editItem.resumoSemanal = this.obj.resumoSemanal;
        this.editItem.novoFornecedor = this.obj.novoFornecedor;
        this.editItem.novoCliente = this.obj.novoCliente;
        this.editItem.vencimentoNF = this.obj.vencimentoNF;
        this.editItem.notaCancelada = this.obj.notaCancelada;
        this.editItem.nvNotaNfe = this.obj.nvNotaNfe;
        this.editItem.nvNotaNfse = this.obj.nvNotaNfse;
        this.dialog = false;
        this.resetObj();
      }
    },
    async salvarItem() {
      await this.verificaEmail();
      if (this.$refs.email.validate()) {
        this.notificacoes.objetos.push(this.obj);
        this.dialog = false;
        this.resetObj();
      }
    },
    resetObj: function() {
      this.obj = {
        email: "",
        resumoDiario: false,
        resumoSemanal: false,
        novoFornecedor: false,
        novoCliente: false,
        vencimentoNF: false,
        notaCancelada: false,
        nvNotaNfe: false,
        nvNotaCte: false,
        nvNotaNfse: false
      };
      this.$refs.email.reset();
    }
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/conta/empresa/formEmpresa/tabNotificacoes/modalAddEdit/ModalAddEdit.vue